import { Pattern, util } from 'fabric';

const TILE_PX = 192;
// Keep perceived brightness >= 50: new text and shapes take their colour from the live canvas
// under them (getVisibleColorAtElementPosition), and that colour is saved and printed.
// Dark enough that white artwork stays readable.
export const FROSTED_FILM_RGB = [180, 185, 191] as const;
export const FROSTED_FILM_COLOR = `rgba(${FROSTED_FILM_RGB.join(', ')}, 1)`;
export const GRAIN_SPREAD = 10;

let filmPattern: Pattern | null | undefined;

// Matte DTF film: one tone with a fine grain. The grain is seeded so every page and
// thumbnail shows the same texture. Null when there is no 2D context (jsdom without node-canvas).
function getFrostedFilmPattern(): Pattern | undefined {
  if (filmPattern === undefined) {
    const source = util.createCanvasElement();
    source.width = TILE_PX;
    source.height = TILE_PX;
    const ctx = source.getContext('2d');
    if (ctx) {
      const [r, g, b] = FROSTED_FILM_RGB;
      const image = ctx.createImageData(TILE_PX, TILE_PX);
      let seed = 7;
      for (let i = 0; i < image.data.length; i += 4) {
        seed = (seed * 16807) % 2147483647;
        const grain = (seed / 2147483647 - 0.5) * GRAIN_SPREAD;
        image.data[i] = r + grain;
        image.data[i + 1] = g + grain;
        image.data[i + 2] = b + grain;
        image.data[i + 3] = 255;
      }
      ctx.putImageData(image, 0, 0);
      filmPattern = new Pattern({ source, repeat: 'repeat' });
    } else {
      filmPattern = null;
    }
  }
  return filmPattern ?? undefined;
}

export default getFrostedFilmPattern;
